import { IconButton, Tooltip, Popover, Theme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import TranslatedMessage from "../../translations/TranslatedMessage";
import AssignmentIcon from "@material-ui/icons/Assignment";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
    },
  })
);

interface CopyToClipboardButtonProps {
  content: string;
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ content }) => {
  const classes = useStyles({});
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const handleCopyToClipboard = (event: any, link: string) => {
    setAnchorElement(event.currentTarget);
    navigator.clipboard.writeText(link);
    setCopiedToClipboard(true);
    setTimeout(() => setCopiedToClipboard(false), 2000); // Hide after 2 seconds
  };

  return (
    <IconButton size="small" onClick={(e) => handleCopyToClipboard(e, content)}>
      <Tooltip title={<TranslatedMessage id="common.copyToClipboard" />}>
        <AssignmentIcon />
      </Tooltip>
      <Popover
        open={copiedToClipboard}
        onClose={() => setCopiedToClipboard(false)}
        anchorEl={anchorElement}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className={classes.popover}>
          <TranslatedMessage id="common.copyToClipboardDone" />
        </div>
      </Popover>
    </IconButton>
  );
};

export default CopyToClipboardButton;
